import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-upairy-compare-card.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';

const DEFAULT_IMAGE = 'https://cdn.skyfastimg.com/images/2026/08/06/image-6a743447c92c8d54188180d5.webp?w=1000';
const GOOD_IMAGE = 'https://cdn.skyfastimg.com/images/2026/08/06/image-6a74357db4a81022f8c0b149.avif?w=1000';
const BAD_IMAGE = 'https://cdn.skyfastimg.com/images/2026/08/06/image-6a74348b791b54e4f5444c7c.webp?w=1000';

const cards = {
  good: {
    title: '<h2 style="text-align:center;"><strong>UpAiry Underwear</strong></h2>',
    image: GOOD_IMAGE,
    alt: 'UpAiry training underwear',
    items: [
      '<p>Eco-Friendly, Reusable for months</p>',
      '<p>Gentle on sensitive skin</p>',
      '<p>Builds Body Awareness</p>',
      '<p>Feels like real underwear</p>',
      '<p>Potty Trains <em>Faster</em></p>',
    ],
    backgroundColor: '#4D903F',
    titleColor: '#FFFFFF',
    itemBackgroundColor: '#FFFFFF',
    itemTextColor: '#242424',
  },
  bad: {
    title: '<h2 style="text-align:center;">Disposables</h2>',
    image: BAD_IMAGE,
    alt: 'Disposable diaper',
    items: [
      '<p>Straight to landfill, single use</p>',
      '<p>Synthetic Materials</p>',
      '<p>Prevents Body Awareness</p>',
      '<p>Feels like a diaper</p>',
      '<p>Potty Trains <em>Slower</em></p>',
    ],
    backgroundColor: '#EAEAEA',
    titleColor: '#242424',
    itemBackgroundColor: '#FFFFFF',
    itemTextColor: '#242424',
  },
};

const renderCard = (type, card) => `
  <article
    class="upairy-compare-card__card upairy-compare-card__card--${type}"
    data-attribute="upairy-compare-card__${type}"
    data-card-background-color="${card.backgroundColor}"
    data-title-color="${card.titleColor}"
    data-item-background-color="${card.itemBackgroundColor}"
    data-item-text-color="${card.itemTextColor}"
    style="
      --card-background-color: ${card.backgroundColor};
      --card-title-color: ${card.titleColor};
      --item-background-color: ${card.itemBackgroundColor};
      --item-text-color: ${card.itemTextColor};
    "
  >
    <img
      class="upairy-compare-card__card-image"
      data-attribute="upairy-compare-card__${type}-image"
      src="${card.image}"
      alt="${card.alt}"
    />
    <div
      class="upairy-compare-card__card-title"
      data-attribute="upairy-compare-card__${type}-title"
    >
      ${card.title}
    </div>
    <div
      class="upairy-compare-card__card-list"
      data-attribute="upairy-compare-card__${type}-list"
    >
      ${card.items
        .map(
          item => `
      <div
        class="upairy-compare-card__card-item"
        data-attribute="upairy-compare-card__${type}-item"
      >
        ${item}
      </div>
      `,
        )
        .join('')}
    </div>
  </article>
`;

const contentHtml = `
  <div class="upairy-compare-card container" data-attribute="upairy-compare-card" data-image-show="true" data-image-position="left">
    <div class="upairy-compare-card__layout" data-attribute="upairy-compare-card__layout">
      <div class="upairy-compare-card__image" data-attribute="upairy-compare-card__image">
        <img loading="lazy" data-attribute="upairy-compare-card__image-element" src="${DEFAULT_IMAGE}" alt="Child wearing UpAiry training underwear" />
      </div>
      <div class="upairy-compare-card__content" data-attribute="upairy-compare-card__content">
        <div class="upairy-compare-card__header" data-attribute="upairy-compare-card__header">
          <h2 style="text-align:center"><strong>The Difference UpAiry Makes</strong></h2>
          <p style="text-align:center">Disposables work against potty training success. UpAiry helps you gets results in weeks, not months.</p>
        </div>
        <div class="upairy-compare-card__cards" data-attribute="upairy-compare-card__cards">
          ${renderCard('good', cards.good)}
          ${renderCard('bad', cards.bad)}
        </div>
        <div class="upairy-compare-card__button" data-attribute="upairy-compare-card__button">
          ${buttonPrimary({
            backgroundColor: '#4B963E',
            color: '#FFFFFF',
            radius: 16,
            text: '👉 START POTTY TRAINING TODAY',
            iconPrefix: { show: false, src: '' },
            iconSuffix: { show: false, src: '' },
            subBtn: { show: false, text: '' },
          })}
        </div>
        <div class="upairy-compare-card__footer" data-attribute="upairy-compare-card__footer">
          <p style="text-align:center"><strong>🕓 LIMITED TIME OFFER •</strong> FREE EBOOK &amp; STICKER CHART</p>
        </div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css);
